// src/features/hira/chunaPendingSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { fetchChunaPendingCount } from "@core/api/encounterChunaApi"

interface ChunaPendingState {
  pendingCount: number
  loading: boolean
  error: string | null
}

const initialState: ChunaPendingState = {
  pendingCount: 0,
  loading: false,
  error: null,
}

const chunaPendingSlice = createSlice({
  name: "chunaPending",
  initialState,
  reducers: {
    setChunaPendingCount(state, action: PayloadAction<number>) {
      state.pendingCount = action.payload
      state.error = null
    },
    incrementChunaPendingCount(state) {
      state.pendingCount += 1
    },
    decrementChunaPendingCount(state) {
      if (state.pendingCount > 0) {
        state.pendingCount -= 1
      }
    },
    setChunaPendingLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setChunaPendingError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
    resetChunaPendingCount(state) {
      state.pendingCount = 0
      state.loading = false
      state.error = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchChunaPendingCount.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchChunaPendingCount.fulfilled, (state, action) => {
        state.loading = false
        state.pendingCount = action.payload
        state.error = null
      })
      .addCase(fetchChunaPendingCount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "추나요법 미제출 건수 조회에 실패했습니다."
      })
  },
})

export const {
  setChunaPendingCount,
  incrementChunaPendingCount,
  decrementChunaPendingCount,
  setChunaPendingLoading,
  setChunaPendingError,
  resetChunaPendingCount,
} = chunaPendingSlice.actions

export default chunaPendingSlice.reducer
